module.exports = __webpack_public_path__ + "static/jooycar-379e2dfbf7bbe60e8368383b5097206b.png";